import {AxiosResponse} from 'axios';
import {axiosInstance} from '../..';

export function getProducts(): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Product`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function getProductId(id: string): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Product/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function createProduct(data: any): Promise<AxiosResponse<any, any>> {
    return axiosInstance.post('Product', data, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function updateProductId(id: string, data: any): Promise<AxiosResponse<any, any>> {
    return axiosInstance.put(`Product/${id}`, data, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}
export function deleteProductId(id: string): Promise<AxiosResponse<any, any>> {
    return axiosInstance.delete(`Product/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}
